import { AxiosError } from 'axios'
import { ECheckForFillingSellerDataError } from 'models/seller'
import { adminRoutes } from 'shared/constants/routes'

interface ISellerDataError {
  message: string
  route: string
}

const sellerDataErrors: Record<ECheckForFillingSellerDataError, ISellerDataError> = {
  [ECheckForFillingSellerDataError.SELLER_INFO_IS_NOT_FILLED_OUT]: {
    message: 'Для вывода средств, заполните все обязательные поля "Основной информации"',
    route: `${adminRoutes.PROFILE}/${adminRoutes.PROFILE_INFO}`
  },
  [ECheckForFillingSellerDataError.DELIVERY_WAYS_IS_NOT_EXIST]: {
    message: 'Для вывода средств, выберите способы доставки вашего магазина',
    route: `${adminRoutes.PROFILE}/${adminRoutes.PROFILE_DELIVERY}`
  },
  [ECheckForFillingSellerDataError.SHOP_IS_NOT_EXIST]: {
    message: 'Для вывода средств добавьте магазин или отключите самовывоз в способах доставки',
    route: `${adminRoutes.PROFILE}/${adminRoutes.PROFILE_SHOPS}`
  },
  [ECheckForFillingSellerDataError.CDEK_POINT_IS_NOT_EXIST]: {
    message: 'Для вывода средств, выберите пункт выдачи заказа для передачи заказов клиентов',
    route: `${adminRoutes.PROFILE}/${adminRoutes.PROFILE_SHOPS}`
  },
  [ECheckForFillingSellerDataError.BANKING_DETAILS_IS_NOT_FILLED_OUT]: {
    message: 'Для вывода средств, заполните банковские сведения',
    route: `${adminRoutes.PROFILE}/${adminRoutes.PROFILE_INFO}`
  }
}

// Подача заявки и включение автовыплат отбиваются одними и теми же проверками данных продавца
export const getSellerDataError = (e: unknown): ISellerDataError | null => {
  const message = (e as AxiosError<{ message?: ECheckForFillingSellerDataError }>)
    .response?.data?.message

  return message && Object.values(ECheckForFillingSellerDataError).includes(message)
    ? sellerDataErrors[message]
    : null
}
